import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ButtonTour from './TourBasicTemplate.styles';

const TourBasicTemplate = ({ tourConfig }) => {
  const [state, setStatus] = useState(tourConfig);
  const translate = useTranslate();

  const { run, stepIndex, steps } = state;

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStatus({
        steps,
        run,
        stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
      });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStatus({ stepIndex: 0, steps, run: false });
    }
  };

  const handleClickOpen = (event) => {
    event.preventDefault();
    setStatus({ stepIndex, steps, run: true });
  };
  return (
    <div>
      <Joyride
        continuous
        scrollToFirstStep
        showProgress
        showSkipButton
        run={run}
        steps={steps}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        locale={{
          back: translate('custom.tour.back'),
          close: translate('custom.tour.close'),
          last: translate('custom.tour.last'),
          next: translate('custom.tour.next'),
          open: translate('custom.tour.open'),
          skip: translate('custom.tour.skip'),
        }}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
      />
      <ButtonTour
        autoFocus={false}
        color="primary"
        onClick={handleClickOpen}
        className="demo__segundo"
      >
        <HelpOutlineIcon />
      </ButtonTour>
    </div>
  );
};

TourBasicTemplate.propTypes = {
  joyride: PropTypes.shape({
    callback: PropTypes.func,
  }),
  tourConfig: PropTypes.shape({
    run: PropTypes.bool,
    stepIndex: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

TourBasicTemplate.defaultProps = {
  joyride: {},
  tourConfig: {},
};

export default TourBasicTemplate;
